var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPreProcess = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.29,
    height: 20.322,
    viewBox: "0 0 21.29 20.322",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_11_",
    transform: "translate(0 -7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    d: "M150.968,232.5a.968.968,0,0,0-.968.968v3.871a.968.968,0,1,0,1.935,0v-3.871A.968.968,0,0,0,150.968,232.5Z",
    transform: "translate(-140.323 -210.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    d: "M150.968,7.5a.968.968,0,0,0-.968.968V10.4a.968.968,0,0,0,1.935,0V8.468A.968.968,0,0,0,150.968,7.5Z",
    transform: "translate(-140.323 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    d: "M5.806,143.468a.968.968,0,0,0-.968-.968H.968a.968.968,0,1,0,0,1.935H4.839A.968.968,0,0,0,5.806,143.468Z",
    transform: "translate(0 -126.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    d: "M244.839,142.5h-3.871a.968.968,0,1,0,0,1.935h3.871a.968.968,0,1,0,0-1.935Z",
    transform: "translate(-224.516 -126.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    d: "M46.955,206.423l-2.737,2.737a.968.968,0,0,0,1.369,1.369l2.737-2.737a.968.968,0,0,0-1.369-1.369Z",
    transform: "translate(-41.1 -185.824)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    d: "M214.606,41.106a.964.964,0,0,0,.684-.283l2.737-2.737a.968.968,0,1,0-1.369-1.369l-2.737,2.737a.968.968,0,0,0,.684,1.652Z",
    transform: "translate(-199.855 -27.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    d: "M215.29,206.423a.968.968,0,1,0-1.369,1.368l2.737,2.737a.968.968,0,0,0,1.369-1.369Z",
    transform: "translate(-199.855 -185.824)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPreProcess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pre-process.82c84af4.svg";
export { ForwardRef as ReactComponent };